module.exports = __webpack_public_path__ + "img/info.c9667b97.png";